import { ReactNode, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { tableRowClassName } from './styles';

interface Props {
  children: ReactNode;
  to?: string;
}

const TableRow = ({ children, to }: Props) => {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    if (to) {
      navigate(to);
    }
  }, [navigate, to]);

  return (
    <tr className={tableRowClassName} onClick={onClick}>
      {children}
    </tr>
  );
};

TableRow.displayName = 'TableRow';

export default TableRow;
